import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { DescriptorData } from "../model/descriptor-data.model";
@Injectable({
  providedIn: "root",
})
export class DescriptorDataService {
  baseUrl = environment.baseUrl;
  constructor(private httpClient: HttpClient) {}

  get(id: string | number): Observable<DescriptorData> {
    return this.httpClient.get<DescriptorData>(
      `${this.baseUrl}descriptor-data/${id}`
    );
  }

  getAll(): Observable<DescriptorData[]> {
    return this.httpClient.get<DescriptorData[]>(
      `${this.baseUrl}descriptor-data`
    );
  }
}
